import ErrorPage from '@/error.vue'
import generatedRoutes from 'virtual:generated-pages'
import {setupLayouts} from 'virtual:generated-layouts'
import {createRouter, createWebHistory} from 'vue-router'
import JwtService from '@/services/jwt.ts'
import {useHighContrast} from '@/composables/useHighContrast'

const routes = [
  ...setupLayouts(generatedRoutes),
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: ErrorPage,
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})


router.beforeEach((to, from, next) => {
  if (to.name === '/sonuc-uyari') {
    JwtService.destroyTokens()
    return next({name: 'giris'});
  }

  if (to.name === "404") return next()

  const hasToken = !!JwtService.getAccessToken()

  const girisSayfasi = to.name === 'giris'
  const kodSayfasi = to.matched.some(record => record.path.startsWith('/giris/')) && !!to.params.kod
  const authSayfasi = girisSayfasi || kodSayfasi

  if (hasToken && girisSayfasi) {
    return next({ path: '/' })
  }

  if (!hasToken && !authSayfasi) {
    return next({ name: 'giris' })
  }

  // Kontrast modu sadece yarisma sayfasında aktif olsun
  const { removeHighContrastClass, restoreHighContrastIfEnabled } = useHighContrast()
  const isYarismaPage = to.path === '/yarisma'
  if (isYarismaPage) {
    restoreHighContrastIfEnabled()
  } else {
    removeHighContrastClass()
  }

  return next();
})

